import Pagination from 'entities/pagination'
import {
  CANCEL_FETCH_TAG,
  FAILURE_FETCH_TAG,
  START_FETCH_TAG,
  SUCCESS_FETCH_TAG,
  MOVE_TAG_PAGE
} from '../constants/action_types'

const initialState = {
  tags: [],
  pagination: Pagination.initializeWithPage(1),
  error: null,
  source: null,
  isLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case START_FETCH_TAG:
      return {
        ...state,
        isLoading: true
      }
    case SUCCESS_FETCH_TAG:
      return {
        ...state,
        tags: action.payload.tags,
        pagination: action.payload.pagination,
        error: null,
        isLoading: false
      }
    case FAILURE_FETCH_TAG:
      return {
        ...state,
        error: action.payload.error,
        isLoading: false
      }
    case CANCEL_FETCH_TAG:
      return {
        ...state,
        source: null,
        isLoading: false
      }
    case MOVE_TAG_PAGE:
      return {
        ...state,
        pagination: state.pagination.updateCurrentPage(action.payload.page)
      }
    default:
      return state
  }
}
